<template>
<main>
  <header>
    <div class="mdd">
      <tourMenu @change="updateCity" class="menu"/>
      <label for="keyword">
        <input v-model="search.keyword" type="text" placeholder="请输入搜索关键词" id="keyword" @change="getList">
        <i class="icon-sousuo"><span>搜索</span></i>
      </label>
    </div>
    <ul class="option">
      <li>
        <span>目的地</span>
        <p>
          <span 
            :class="{ on: v.id === search.listId }" 
            v-for="v in deploy.list" :key="v.i"
            @click="changeSearch('listId', v.id)">{{v.text}}</span>
        </p>
      </li>
      <li>
        <span>出发城市</span>
        <p>
          <span 
            :class="{ on: v.id === search.city }" 
            v-for="v in deploy.city" :key="v.id"
            @click="changeSearch('city', v.id)">{{v.text}}</span>
        </p>
      </li>
      <li>
        <span>特色体验</span>
        <p>
          <span 
            :class="{ on: v.id === search.tip }" 
            v-for="v in deploy.tip" :key="v.id"
            @click="changeSearch('tip', v.id)">{{v.text}}</span>
        </p>
      </li>
      <li>
        <span>出发时间</span>
        <p>
          <span 
            :class="{ on: i === search.dateIndex }" 
            v-for="(v, i) in deploy.dates" :key="v.value"
            @click="changeDates(v, i)">{{v.title}}</span>
          <el-date-picker
            :clearable="true"
            v-model="search.date"
            size="mini"
            placeholder="出行日期"
            type="daterange"
            class="date"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="changeDates">
          </el-date-picker>
        </p>
      </li>
      <li>
        <span>行程天数</span>
        <p>
          <span 
            :class="{ on: i+1 === search.day }" 
            v-for="(v, i) in deploy.day" :key="v.value"
            @click="changeSearch('day', v.value)">{{v.text}}</span>
        </p>
      </li>
    </ul>
  </header>
  <ul class="list">
    <li v-for="v in list" :key="v.id" @click="goDetail(v.id)">
      <figure>
        <img :src="imgUrl + v.img" alt="">
        <span>出发城市：{{v.city_text || '--'}}</span>
      </figure>
      <div class="info">
        <h3>{{v.full_title}}</h3>
        <p class="tags">
          <span v-for="s in v.themes" :key="s.id">{{s.title}}</span>
        </p>
        <div class="bold">
          <p class="address">
            <span>目的地：</span>
            <b>{{v.destinations[0] ? v.destinations[0].title : '--'}}</b>
          </p>
          <b class="price">{{v.best_price}}</b>
        </div>
      </div>
    </li>
  </ul>
  <el-pagination
    class="pages"
    background
    layout="prev, pager, next"
    :page-count="last"
    @current-change="changePage">
  </el-pagination>
</main>
</template>

<script>
import $tour from '@api/tour';
import $tool from '@assets/js/tool/tour';
import tourMenu from '@components/tourMenu/index';
export default {
  components: {
    tourMenu
  },
  data () {
    return {
      search: {
        listIndex: 0,
        listId: null,
        city: null,
        tip: null,
        day: null,
        date: [],
        dateIndex: null,
        keyword: null,
        page: 1,
        rows: 10
      },
      deploy: {
        city: [],
        tip: [],
        day: [],
        dates: [{
          title: '端午',
          start_date: '2021-06-11',
          end_date: '2021-06-14'
        }, {
          title: '中秋',
          start_date: '2021-06-11',
          end_date: '2021-06-14'
        }, {
          title: '国庆',
          start_date: '2021-06-11',
          end_date: '2021-06-14'
        }],
        list: [{}]
      },
      list: [],
      last: 0
    }
  },
  async created () {

    this.initSearch();
    await this.getBaseData();
    this.getList();
    this.scrollTo();
  },
  methods: {
    changeDates (v, i = null) {
      let date;
      if ( i === null ) {
        date = v !== null ? [...v] : [];
      } else {
        const { start_date, end_date } = v;
        date = [start_date, end_date];
      }
      this.search = { ...this.search, dateIndex: i };
      this.changeSearch('date', date);
    },
    initSearch () {
      const { query } = this.$route;
      const search = { ...this.search, ...query };
      this.search = search;
    },
    goDetail (id) {
      this.$router.push({ path: '/tour/'+id });
    },
    async getBaseData () {
      const { TourDepartureCity: city, TourThemeTip: tip, TourDestinationV2: destination, QuickSearchDate: dates } = await $tool.getBaseData();
      const [ { children: [ { children, id: leave3Id } ] } ] = destination;

      let { list = false, id } = this.$route.params;

      if ( list == false ) {
        list = [{ text: '全部', id: id || leave3Id }, ...children];
      }

      this.deploy = { ...this.deploy, city, dates, tip, list, day: [...new Array(15)].map((v, i) => ({ value: i+1, text: i < 14 ? `${i+1}天` : `${i+1}天以上` })) };

      this.search = { ...this.search, listId: id || leave3Id };

      return true;
    },
    changeSearch (attr, value) {
      let val;
      if ( attr !== 'listId' ) {
        val = this.search[attr] === value ? null : value;
      } else {
        val = value;
      }
      const search = { ...this.search, [attr]: val, page: 1 };
      this.search = search;
      this.getList();
    },
    async getList () {
      const data = this.getListData();
      const { data: list, last_page } = await $tour.list(data);
      this.list = list;
      this.last = last_page;
    },
    getListData () {
      const { city, day: days, date, keyword, listId: destinationid, tip: themeid, rows, page } = this.search;
      const [ sdate, edate ] = date || [];
      return {
        cityid: city,
        destinationid,
        themeid,
        sdate, edate, days,
        keyword,
        page, rows
      }
    },
    changePage (i) {
      this.search = { ...this.search, page: i };
      this.getList();
    },
    updateCity (data) {
      const { list, id } = data;
      this.deploy = {...this.deploy, list};
      this.changeSearch('listId', id);
    }
  }
}
</script>

<style src="./list.css" scoped></style>